import add from "../../static/images/add.png";
import addWhite from "../../static/images/add-white.png";
import backIcon from "../../static/images/back.png";
import bg from "../../static/images/bg1.jpg";
import calendarWhite from "../../static/images/calendar.png";
import calendar from "../../static/images/calendar-blc.png";
import cancel from "../../static/images/cancel.png";
import cancelGray from "../../static/images/cancel-gray.png";
import checkBlue from "../../static/images/check-blue.png";
import deleteRed from "../../static/images/delete.png";
import question from "../../static/images/delete-icon.png";
import document from "../../static/images/document.png";
import downArrow from "../../static/images/down-arrow.png";
import edit from "../../static/images/edit.png";
import editPen from "../../static/images/edit-pen.png";
import error from "../../static/images/error-icon.png";
import eye from "../../static/images/eye.png";
import folder from "../../static/images/folder.png";
import tickCycleGreen from "../../static/images/green tick.png";
import history from "../../static/images/history.png";
import logo from "../../static/images/HRM_logo_2021_NT_2048x2048.png";
import logoItem from "../../static/images/HRM_logo_2021_V_2048x1024.png";
import iconAdmin from "../../static/images/iconAdmin.png";
import iconApproval from "../../static/images/iconApproval.png";
import iconCandidate from "../../static/images/iconCandidate.png";
import iconEmployee from "../../static/images/iconEmployee.png";
import iconMM from "../../static/images/iconMM.png";
import iconOutdoorwork from "../../static/images/iconOutdoorwork.png";
import iconReport from "../../static/images/iconReport.png";
import iconSetup from "../../static/images/iconsetup.png";
import icooLeaveApp from "../../static/images/icooLeaveApp.png";
import info from "../../static/images/info-button.png";
import leftArrow from "../../static/images/left-arrow-black-triangle.png";
import rightArrow from "../../static/images/right-arrow-black-triangle.png";
import downMenu from "../../static/images/menu-down-dark.png";
import rightMenu from "../../static/images/menu-right-dark.png";
import upMenu from "../../static/images/menu-up-dark.png";
import plane from "../../static/images/plane.png";
import printBlue from "../../static/images/print-blue.png";
import printer from "../../static/images/printer.png";
import cancelRed from "../../static/images/red cancel.png";
import cancelRed2 from "../../static/images/red-cancel.png";
import refresh from "../../static/images/refresh.png";
import rubbish from "../../static/images/rubbish bin.png";
import save from "../../static/images/save.png";
import saveWhite from "../../static/images/save-white.png";
import search from "../../static/images/search.png";
import searchWhite from "../../static/images/search-white.png";
import terminateWhite from "../../static/images/terminatenew.png";
import tick from "../../static/images/tick.png";
import tickGreen from "../../static/images/tick-gr.png";
import upload from "../../static/images/upload.png";
import uploadGrey from "../../static/images/upload1.png";
import uploadWhite from "../../static/images/upload-white.png";
import expansion from "../../static/images/up-right-and-down-left-from-center-solid 2.png";
import vector from "../../static/images/Vector.png";

const images = {
    add,
    addWhite,
    backIcon,
    bg,
    calendarWhite,
    calendar,
    cancel,
    cancelGray,
    checkBlue,
    deleteRed,
    question,
    document,
    downArrow,
    edit,
    editPen,
    error,
    eye,
    folder,
    tickCycleGreen,
    history,
    logo,
    logoItem,
    iconAdmin,
    iconApproval,
    iconCandidate,
    iconEmployee,
    iconMM,
    iconOutdoorwork,
    iconReport,
    iconSetup,
    icooLeaveApp,
    info,
    leftArrow,
    rightArrow,
    downMenu,
    rightMenu,
    upMenu,
    plane,
    printBlue,
    printer,
    cancelRed,
    cancelRed2,
    refresh,
    rubbish,
    save,
    saveWhite,
    search,
    searchWhite,
    terminateWhite,
    tick,
    tickGreen,
    upload,
    uploadGrey,
    uploadWhite,
    expansion,
    vector
};
export default images


// WEBPACK FOOTER //
// ./src/constants/image.js